import { useAuth0 } from '@auth0/auth0-react';
import { SessionStorageService } from '@ion/user';

export default function LogoutPage() {
  const { logout } = useAuth0();

  SessionStorageService.clearSessionOrgInfo();
  logout();
  return null;
}
